<template>
    <sidebar-layout :moduleCode="moduleCode" :subModuleCode="subModuleCode">

        <template v-slot:aside-main-menu>
            <GestaoMenu
                :moduleCode="moduleCode"
                :items="menuItemsFiltered" />
        </template>

        <template v-slot:main>
            <div :class="moduleCode + '-page'">
                <slot></slot>
            </div>
        </template>

    </sidebar-layout>
</template>


<script>
import GestaoMenu from '@/app/shared/components/menu/GestaoMenu.vue';
import ModuleMixin from '../shared/mixins/ModuleMixin';
import { typeOfInterventions } from '../shared/config';

export default {
    mixins: [
        ModuleMixin
    ],
    components: {
        GestaoMenu,
    },
    data() {
        return {
        }
    },
    computed: {
        menuItems(){
            return this.$store.getters.getMainMenu(this.moduleCode);
        },
        isRoot() {
            return this.currentIntervention === null;
        },
        currentIntervention() {
            let choseItem = null
            typeOfInterventions.forEach(item => {
                let er = new RegExp(item.basePath);
                if(er.test(this.$route.path)) choseItem = item;
            });
            return choseItem;
        },
        subModuleCode() {
            return this.currentIntervention ? this.currentIntervention.basePath : null;
        },
        menuItemsFiltered() {
            if(this.isRoot) {
                let types = [];
                typeOfInterventions.forEach(item => {
                    types.push(item.key);
                });
                let er = new RegExp(`(${types.join('|')})`);
                return this.menuItems.filter((item) => {
                    return (
                        !er.test(item.route) &&
                        (
                            !item.route.match(new RegExp(`home`, 'gi')) ||
                            item.route.match(new RegExp(`^${this.moduleCode}\..*\.home$`, 'gi'))
                        )
                    )
                });
            } else {
                let er = new RegExp(`${this.currentIntervention.key}`);
                let erHome = new RegExp(`^${this.moduleCode}\.home$`, 'gi');
                let erManageHome = new RegExp(`^${this.moduleCode}\.${this.currentIntervention.basePath}\.home$`, 'gi');
                let erFrontHome = new RegExp(`^${this.moduleCode.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}\.${this.currentIntervention.basePath}\.home$`);
                return this.menuItems.filter((item) => {
                    let route = item.route;
                    return /^home$/.test(route) || er.test(route) || erHome.test(route) || erManageHome.test(route) || erFrontHome.test(route);
                });
            }
        }
    }
}
</script>
